import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as externalPersonnel from '../../external-personnel'

export const RESOURCE = {
  payload: {
    description:
      'An individual affiliated with, but not employed by, the institution who contributes to research initiatives.',
    dimension: externalPersonnel.RESOURCE.payload,
    level: 0,
    name: 'External Employee',
    partialId: PartialId.Standard.create('employee'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
